/** DueChipPicker.tsx — 마감일 빠른 선택 칩 [없음][오늘][내일][모레][직접] */
import { useState } from 'react';
import { C, T, R } from './ui';

interface Props {
  value: string | null;
  onChange: (v: string | null) => void;
  size?: 'sm' | 'md';
}

function ymd(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export default function DueChipPicker({ value, onChange, size = 'md' }: Props) {
  const [customOpen, setCustomOpen] = useState(false);
  const today = ymd(new Date());
  const tom = ymd(new Date(Date.now() + 86400000));
  const dayAfter = ymd(new Date(Date.now() + 2 * 86400000));

  const opts: { label: string; v: string | null }[] = [
    { label: '없음', v: null },
    { label: '오늘', v: today },
    { label: '내일', v: tom },
    { label: '모레', v: dayAfter },
  ];

  const pad = size === 'sm' ? '3px 9px' : '5px 11px';
  const fs = size === 'sm' ? T.xs : T.sm;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: 'center' }}>
      {opts.map(o => {
        const act = value === o.v;
        return (
          <button key={String(o.v)} onClick={() => { onChange(o.v); setCustomOpen(false); }}
            style={{ padding: pad, borderRadius: R.sm,
              border: act ? `1.5px solid ${C.accent}` : `1px solid ${C.border}`,
              background: act ? C.accentLt : C.white,
              color: act ? C.accent : C.sub,
              fontSize: fs, fontWeight: act ? 700 : 500, cursor: 'pointer' }}>
            {o.label}
          </button>
        );
      })}
      <button onClick={() => setCustomOpen(v => !v)}
        style={{ padding: pad, borderRadius: R.sm,
          border: `1px solid ${customOpen || (value && !opts.find(o=>o.v===value)) ? C.accent : C.border}`,
          background: customOpen ? C.accentLt : C.white,
          color: C.sub, fontSize: fs, fontWeight: 500, cursor: 'pointer' }}>
        📅 직접
      </button>
      {(customOpen || (value && !opts.find(o => o.v === value))) && (
        <input type="date" value={value || ''}
          onChange={e => onChange(e.target.value || null)}
          style={{ padding: pad, borderRadius: R.sm, boxSizing: 'border-box',
            border: `1px solid ${C.border}`, fontSize: fs, color: C.text,
            fontFamily: 'inherit', lineHeight: 1.2 }} />
      )}
    </div>
  );
}
